"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInputisEmpty = void 0;
function FileInputisEmpty(controller, dropzone) {
    const updateClass = () => {
        const hasFiles = controller.getFiles().length > 0;
        dropzone.classList.toggle('is-empty', !hasFiles);
    };
    controller.onFileAdded(updateClass);
    controller.onFileRemoved(updateClass);
    updateClass();
}
exports.FileInputisEmpty = FileInputisEmpty;
